import React from 'react'
import styled from '@emotion/styled'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import HeadingBorder from 'src/components/atoms/HeadingBorder'
import HeadTitle from 'src/components/atoms/HeadTitle'
import partnerExchangeImg from 'src/images/partner/support/partner-exchange.png'
import studySupportImg from 'src/images/partner/support/study-support.png'
import salseSupportImg from 'src/images/partner/support/salse-support.png'
import marketingSupportImg from 'src/images/partner/support/marketing-support.png'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'

export const PartnerSupport= () => {
    return (
        <Container>
            <ContentsWrapper>
            <HeadingBorder heading="SUPPORT" />
            <HeadTitle>パートナー活動支援</HeadTitle>
            <ColumnWrapper>
            
                <Column>
                    <VectorImage src={partnerExchangeImg} alt="パートナー同士の交流" />
                    <Title as="h3">パートナー同士の交流</Title>
                    <Description>パートナー企業同士のコミュニティを形成。相互交流を通して、ナレッジ共有を促進します。</Description>
                </Column>
                <Column>
                    <VectorImage src={studySupportImg} alt="学習支援" />
                    <Title as="h3">学習支援</Title>
                    <Description>定期的な勉強会の開催、オンライン学習プログラムなど、パートナーの学習を支援しております。</Description>
                </Column>
                <Column>
                    <VectorImage src={salseSupportImg} alt="営業支援コンテンツ" />
                    <Title as="h3">営業支援コンテンツ</Title>
                    <Description>ノウハウの詰まった提案資料や動画など、提案時にご利用いただけるコンテンツを多数ご用意しております。</Description>
                </Column>
                <Column>
                    <VectorImage src={marketingSupportImg} alt="マーケティング支援" />
                    <Title as="h3">マーケティング支援</Title>
                    <Description>共催セミナーの実施、webページへの掲載など、多数のマーケテイング支援を受けられます。</Description>
                </Column>
            </ColumnWrapper>
            </ContentsWrapper>
        </Container>
    )
}

const Container = styled.div`
    padding: 48px 0;
`

const ColumnWrapper= styled.div`
    padding: 0 0 ${Styles.spacing[11]};
    max-width: 990px;
    margin: auto;
    display: flex;
    flex-direction: column;
    gap: ${Styles.spacing[10]};
    text-align: center;
    @media screen and (min-width: ${BreakPoint.TABLET}) {
        padding: 0 30px ${Styles.spacing[13]};
        flex-direction: row;
    }
`

const Column = styled.div`

`

const Title = styled.div`
    color: ${Styles.color.primary[400]};
    font-size: ${Styles.fontSize[400]};
    font-weight: ${Styles.fontWeight.bold};
    line-height: ${Styles.lineHeight[400]};
    letter-spacing: ${Styles.letterSpacing[400]};
    
    @media screen and (min-width: ${BreakPoint.TABLET}) {
        font-size: ${Styles.fontSize[500]};
        flex: 1;
        min-width: 0;
        align-items: center;
        justify-content: center;
        margin-bottom: 30px;
    }
`

const Description = styled.dev`
    margin: ${({ spVariant }) =>
        spVariant === 'center'
        ? `${Styles.spacing[7]} 0 0`
        : `${Styles.spacing[6]} 0 0`};
    font-size: ${Styles.fontSize[300]};
    line-height: ${Styles.lineHeight[400]};
    letter-spacing: ${Styles.letterSpacing[400]};
    @media screen and (min-width: ${BreakPoint.TABLET}) {
        font-size: ${Styles.fontSize[400]};
    }
`

const VectorImage = styled.img`
    max-width: 40%;
    height: auto;
    align-self: flex-start;
    margin: calc(${Styles.spacing[4]} * -1) 0 0 calc(${Styles.spacing[4]} * -1);
    @media screen and (min-width: ${BreakPoint.MOBILE}) {
        margin: 0 0 0 calc(${Styles.spacing[4]} * -1);
    }
    @media screen and (min-width: ${BreakPoint.TABLET}) {
        margin: 0;
        max-width: 50%;
        max-height: 36%;
    }
`